import { translationKey } from '@change-corgi/core/i18n';
import type { TranslationKey } from '@change-corgi/core/i18n';

import type { SuggestedPetition } from '../api';

export function getTitleI18n(suggestedPetitions: readonly SuggestedPetition[]): TranslationKey {
	if (suggestedPetitions.some(({ type }) => type === 'PROMOTED'))
		return translationKey('fe.pages.home.promoted_petitions.header');
	if (suggestedPetitions.some(({ type }) => type === 'RECOMMENDED'))
		return translationKey('fe.pages.home.recommended_petitions.header');
	if (suggestedPetitions.some(({ type }) => type === 'TRENDING'))
		return translationKey('fe.components.trending_petition.header');
	// TODO: Refactor this to show a loading state for the title of each section
	return translationKey('fe.pages.home.promoted_petitions.header');
}
